module.exports = __webpack_public_path__ + "assets/present-icon-purple.4beb658b68b0a84436d56f42cabf0718.svg";